import { Badge, Body } from '@e2n/ui/v2';
import { ArbeitsbereichOption } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitsbereichOption';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SelectV2';
import { useArbeitsbereicheOptions } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useArbeitsbereicheOptions/useArbeitsbereicheOptions';
import { faCheck, faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichSelect({
  handleChange,
  standortId,
  mitarbeiter,
  value,
  disabled = false,
}: {
  handleChange: (arbeitsbereich: ArbeitsbereichOption) => void;
  standortId: string;
  mitarbeiter: Mitarbeiter;
  value: ArbeitsbereichOption;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const { arbeitsbereiche } = useArbeitsbereicheOptions([standortId]);

  return (
    <Select<ArbeitsbereichOption>
      disabled={disabled}
      selectedOption={value}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createStation.fields.arbeitsbereich.label',
      )}
      options={arbeitsbereiche}
      renderTriggerContent={(selectedArbeitsbereich) =>
        selectedArbeitsbereich ? (
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              color={
                disabled
                  ? selectedArbeitsbereich.getFillColor()
                  : selectedArbeitsbereich.getBorderColor()
              }
              icon={faCircle}
              className="size-2.5"
            />
            <Body className="truncate">{selectedArbeitsbereich.name}</Body>
          </div>
        ) : (
          <div>{t('actions.auswaehlen')}</div>
        )
      }
      renderListItem={(arbeitsbereich, selectedArbeitsbereich) => (
        <div className="flex w-full items-center gap-2">
          <FontAwesomeIcon
            className="size-2.5"
            color={arbeitsbereich.getBorderColor()}
            icon={faCircle}
          />
          <Body className="min-w-0 truncate">{arbeitsbereich.name}</Body>
          {mitarbeiter.arbeitsbereich?.id === arbeitsbereich.id && (
            <Badge className="bg-neutrals-v2-200 text-labels-primary">
              {t('domain.mitarbeiter.rotationsplan.primaererArbeitsbereich')}
            </Badge>
          )}
          {arbeitsbereich.id === selectedArbeitsbereich?.id && (
            <FontAwesomeIcon
              className="ml-auto size-4 text-brand-red-200"
              icon={faCheck}
            />
          )}
        </div>
      )}
    />
  );
}
